import { useNavigate } from "react-router-dom";
import "../../../styles/components/home/categories/homeCategoryCardContainer.scss";
import { resolveTileRoute } from "../../../utils/categories/categoryTree";

export const HomeCategoryCardContainer = ({ category }) => {
  const navigate = useNavigate();

  // 0026: route into the gallery via the SAME helper the gallery uses — categories with
  // sub-groups drill to /gallery/:id, leaf categories fall back to the existing product
  // route. Single source of truth for the leaf-vs-children decision.
  const handleClick = () => {
    navigate(resolveTileRoute(category, null));
  };

  return (
    <div className="homeCategoryCardContainer" onClick={handleClick}>
      <div className="imageContainer">
        <img src={category.imageURL} alt={category.name} />
      </div>
      <div className="detailsContainer">
        <h3>{category.categoryName}</h3>
      </div>
    </div>
  );
};

export default HomeCategoryCardContainer;
